import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getTotalData } from '@/service/warehouse/requisition';
export default function useTotalData(params) {
  var totalData = ref({
    release_money: 0,
    count: 0
  });
  var getTotalDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getTotalData(params.value);
          case 2:
            data = _context.sent;
            totalData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getTotalDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var summaryData = computed(function () {
    var _totalData$value, _totalData$value2;
    return [{
      num: (_totalData$value = totalData.value) === null || _totalData$value === void 0 ? void 0 : _totalData$value.count,
      desc: '本月领用次数'
    }, {
      num: (_totalData$value2 = totalData.value) === null || _totalData$value2 === void 0 ? void 0 : _totalData$value2.release_money,
      desc: '领用总金额/万'
    }];
  });
  return [totalData, summaryData, getTotalDataAsync];
}